import { useEffect, useMemo, useState } from "react";

// Keep the image's native pixel grid; CSV dimensions are used until it loads.
export function useImageSize(src, fallback) {
  const [loaded, setLoaded] = useState(null);

  useEffect(() => {
    if (!src) return undefined;
    let active = true;
    const image = new Image();
    image.onload = () => {
      if (active && image.naturalWidth && image.naturalHeight) {
        setLoaded({ src, width: image.naturalWidth, height: image.naturalHeight });
      }
    };
    image.src = src;
    return () => { active = false; image.onload = null; };
  }, [src]);

  const width = loaded?.src === src ? loaded.width : fallback.width;
  const height = loaded?.src === src ? loaded.height : fallback.height;
  return useMemo(() => ({ width, height }), [width, height]);
}
